"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5942],{

/***/ 55942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FloatingIntegrationsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/constants.js
var MIN_SCALE_TIMEOUT = 0;
var MAX_SCALE_TIMEOUT = 10000;
var MIN_SCALE_VALUE = 0.9;
var MAX_SCALE_VALUE = 1.1;
var MIN_TRANSLATE_Y_TIMEOUT = 1500;
var MAX_TRANSLATE_Y_TIMEOUT = 3000;
var MIN_TRANSLATE_Y_VALUE = -5;
var MAX_TRANSLATE_Y_VALUE = 5;
var ITEM_TOTAL_HEIGHT = 120;
var ITEM_WIDTH = 107;
var ITEM_MARGIN = 32;
var ITEM_TOTAL_WIDTH = ITEM_WIDTH + ITEM_MARGIN;
var SLIDER_MARGIN = 24;
var NUMBER_OF_ROWS = 2;
var MAX_INTEGRATIONS_FLOATING_WIDTH = 3000;

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/components/integrations-slider/integrations-slider-component.scss.js

var SLIDER_MARGIN_PX = "".concat(SLIDER_MARGIN, "px");
var componentStyles = new String(".integrations-slider-component.jsx-bcc8ef5a18791482{position:relative;padding:".concat(SLIDER_MARGIN_PX, " 0;.integration-badge-wrapper{position:absolute}}"));
componentStyles.__hash = "bcc8ef5a18791482";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/components/integration-badge/integration-badge-component.scss.js

var IMAGE_HEIGHT = "".concat(ITEM_TOTAL_HEIGHT, "px");
var IMAGE_WIDTH = "".concat(ITEM_WIDTH, "px");
var integration_badge_component_scss_componentStyles = new String(".integration-badge-component.jsx-2d9c6e40b9a7e584{-webkit-transition:-webkit-transform 1s linear;-moz-transition:-moz-transform 1s linear;-o-transition:-o-transform 1s linear;transition:-webkit-transform 1s linear;transition:-moz-transform 1s linear;transition:-o-transform 1s linear;transition:transform 1s linear}.integration-badge-image{height:".concat(IMAGE_HEIGHT, ";width:").concat(IMAGE_WIDTH, "}"));
integration_badge_component_scss_componentStyles.__hash = "2d9c6e40b9a7e584";

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/components/integration-badge/integration-badge-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var IntegrationBadge = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IntegrationBadge, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IntegrationBadge);
    function IntegrationBadge() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, IntegrationBadge);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "animate", function() {
            // Scale animation
            _this.animatePicture({
                repeat: true,
                min: MIN_SCALE_VALUE,
                max: MAX_SCALE_VALUE,
                attribute: "scale",
                timeout: function() {
                    return _this.randomNumber(MIN_SCALE_TIMEOUT, MAX_SCALE_TIMEOUT);
                }
            });
            // Floating animation
            _this.animatePicture({
                repeat: true,
                min: MIN_TRANSLATE_Y_VALUE,
                max: MAX_TRANSLATE_Y_VALUE,
                attribute: "translateY",
                unit: "px",
                timeout: function() {
                    return _this.randomNumber(MIN_TRANSLATE_Y_TIMEOUT, MAX_TRANSLATE_Y_TIMEOUT);
                }
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "animatePicture", function(options) {
            var randomTimeout = options.timeout();
            setTimeout(function() {
                window.requestAnimationFrame(function() {
                    var random = _this.randomNumber(options.min, options.max);
                    if (_this.pictureContainer) {
                        _this.pictureContainer.style.transform = "".concat(options.attribute, "(").concat(random).concat(options.unit || "", ")");
                    }
                    if (options.repeat) {
                        _this.animatePicture(options);
                    }
                });
            }, randomTimeout);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "setPictureContainer", function(element) {
            _this.pictureContainer = element;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(IntegrationBadge, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.animate();
            }
        },
        {
            key: "randomNumber",
            value: function randomNumber(min, max) {
                return Math.random() * (max - min) + min;
            }
        },
        {
            key: "render",
            value: function render() {
                var path = this.props.path;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: this.setPictureContainer,
                    className: "jsx-".concat(integration_badge_component_scss_componentStyles.__hash) + " " + "integration-badge-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            className: "integration-badge-image",
                            src: path
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: integration_badge_component_scss_componentStyles.__hash,
                            children: integration_badge_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return IntegrationBadge;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/components/integrations-slider/integrations-slider-component.js





function integrations_slider_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var IntegrationsSliderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IntegrationsSliderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IntegrationsSliderComponent);
    function IntegrationsSliderComponent(props) {
        (0,_class_call_check/* default */.Z)(this, IntegrationsSliderComponent);
        var _this;
        _this = _super.call(this, props);
        integrations_slider_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "animate", function() {
            var step = function() {
                window.requestAnimationFrame(step);
                _this.itemRefs.forEach(function(item) {
                    item.xPos = item.xPos + 0.5;
                    if (item.xPos > _this.size - ITEM_TOTAL_WIDTH) {
                        item.xPos -= _this.size;
                    }
                    if (item.element) {
                        item.element.style.transform = "translate(".concat(item.xPos, "px, ").concat(item.yPos, "px)");
                    }
                });
            };
            window.requestAnimationFrame(step);
        });
        integrations_slider_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setItems", function(element, xPos, yPos) {
            _this.itemRefs.push({
                element: element,
                xPos: xPos,
                yPos: yPos
            });
        });
        _this.itemRefs = [];
        _this.size = props.integrationBadges.length / NUMBER_OF_ROWS * ITEM_TOTAL_WIDTH;
        return _this;
    }
    (0,_create_class/* default */.Z)(IntegrationsSliderComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.animate();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, integrationBadges = _props.integrationBadges, className = _props.className;
                var containerClasses = classnames_default()(className, "integrations-slider-component");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(componentStyles.__hash) + " " + (containerClasses || ""),
                    children: [
                        integrationBadges.map(function(i, index) {
                            // X Position is translated to be absolute the index * width
                            var xPos = -1 * index * (ITEM_TOTAL_WIDTH / NUMBER_OF_ROWS) + MAX_INTEGRATIONS_FLOATING_WIDTH;
                            // Y Position will change whether it's odd or even accordingly
                            var yPos = index % 2 === 0 ? 0 : ITEM_TOTAL_HEIGHT;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: function(e) {
                                    return _this.setItems(e, xPos, yPos);
                                },
                                className: "jsx-".concat(componentStyles.__hash) + " " + "integration-badge-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationBadge, {
                                    path: i.path
                                }, i.key)
                            }, "integration_".concat(index));
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return IntegrationsSliderComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/integrationBadges.js
var badges = [
    // IMPORANT: ONLY EVEN NUMBER OF INTERGRATIONS IS SUPPROTED!
    {
        key: "mailchimp",
        path: "/static/img/segment-layout-default-images/floating-integrations/mailchimp.png"
    },
    {
        key: "twitter",
        path: "/static/img/segment-layout-default-images/floating-integrations/twitter.png"
    },
    {
        key: "box",
        path: "/static/img/segment-layout-default-images/floating-integrations/box.png"
    },
    // { key: "eventbrite", path: "/static/img/segment-layout-default-images/floating-integrations/eventbrite.png" },
    {
        key: "facebook-ads",
        path: "/static/img/segment-layout-default-images/floating-integrations/facebook-ads.png"
    },
    {
        key: "facebook",
        path: "/static/img/segment-layout-default-images/floating-integrations/facebook.png"
    },
    {
        key: "harvest",
        path: "/static/img/segment-layout-default-images/floating-integrations/harvest.png"
    },
    {
        key: "jira-core",
        path: "/static/img/segment-layout-default-images/floating-integrations/jira-core.png"
    },
    {
        key: "surveymonkey",
        path: "/static/img/segment-layout-default-images/floating-integrations/surveymonkey.png"
    },
    {
        key: "twilio",
        path: "/static/img/segment-layout-default-images/floating-integrations/twilio.png"
    },
    {
        key: "zendesk",
        path: "/static/img/segment-layout-default-images/floating-integrations/zendesk.png"
    },
    {
        key: "todoist",
        path: "/static/img/segment-layout-default-images/floating-integrations/todoist.png"
    },
    {
        key: "stripe",
        path: "/static/img/segment-layout-default-images/floating-integrations/stripe.png"
    },
    {
        key: "shopify",
        path: "/static/img/segment-layout-default-images/floating-integrations/shopify.png"
    },
    {
        key: "salesforce",
        path: "/static/img/segment-layout-default-images/floating-integrations/salesforce.png"
    },
    {
        key: "pipedrive",
        path: "/static/img/segment-layout-default-images/floating-integrations/pipedrive.png"
    },
    {
        key: "webhooks",
        path: "/static/img/segment-layout-default-images/floating-integrations/webhooks.png"
    },
    {
        key: "typeform",
        path: "/static/img/segment-layout-default-images/floating-integrations/typeform.png"
    },
    // { key: "wave", path: "/static/img/segment-layout-default-images/floating-integrations/wave.png" },
    {
        key: "redash",
        path: "/static/img/segment-layout-default-images/floating-integrations/redash.png"
    },
    {
        key: "toggl",
        path: "/static/img/segment-layout-default-images/floating-integrations/toggl.png"
    },
    {
        key: "slack",
        path: "/static/img/segment-layout-default-images/floating-integrations/slack.png"
    },
    // { key: "paypal", path: "/static/img/segment-layout-default-images/floating-integrations/paypal.png" },
    {
        key: "outlook",
        path: "/static/img/segment-layout-default-images/floating-integrations/outlook.png"
    },
    {
        key: "ms-teams",
        path: "/static/img/segment-layout-default-images/floating-integrations/ms-teams.png"
    },
    {
        key: "jira",
        path: "/static/img/segment-layout-default-images/floating-integrations/jira.png"
    },
    {
        key: "linkedin",
        path: "/static/img/segment-layout-default-images/floating-integrations/linkedin.png"
    },
    {
        key: "jotform",
        path: "/static/img/segment-layout-default-images/floating-integrations/jotform.png"
    },
    {
        key: "hubspot",
        path: "/static/img/segment-layout-default-images/floating-integrations/hubspot.png"
    },
    // { key: "intercom", path: "/static/img/segment-layout-default-images/floating-integrations/intercom.png" },
    {
        key: "dropbox",
        path: "/static/img/segment-layout-default-images/floating-integrations/dropbox.png"
    },
    // { key: "hackerone", path: "/static/img/segment-layout-default-images/floating-integrations/hackerone.png" },
    {
        key: "google-calendar",
        path: "/static/img/segment-layout-default-images/floating-integrations/google-calendar.png"
    },
    {
        key: "google-drive",
        path: "/static/img/segment-layout-default-images/floating-integrations/google-drive.png"
    },
    {
        key: "github",
        path: "/static/img/segment-layout-default-images/floating-integrations/github.png"
    },
    {
        key: "gmail",
        path: "/static/img/segment-layout-default-images/floating-integrations/gmail.png"
    },
    {
        key: "gitlab",
        path: "/static/img/segment-layout-default-images/floating-integrations/gitlab.png"
    },
    {
        key: "excel",
        path: "/static/img/segment-layout-default-images/floating-integrations/excel.png"
    },
    {
        key: "copper",
        path: "/static/img/segment-layout-default-images/floating-integrations/copper.png"
    },
    {
        key: "github",
        path: "/static/img/segment-layout-default-images/floating-integrations/github.png"
    }
];
var duplicateBadges = function() {
    return badges.concat(badges);
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/floating-integrations-component.scss.js



var HEIGHT = "".concat((ITEM_TOTAL_HEIGHT + SLIDER_MARGIN) * NUMBER_OF_ROWS, "px");
var StyledFloatingIntegrationsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egynv4i0"
})("max-width:", MAX_INTEGRATIONS_FLOATING_WIDTH, "px;margin:auto;height:", HEIGHT, ";overflow-x:hidden;");

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/floating-integrations-component.js









var FloatingIntegrationsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FloatingIntegrationsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FloatingIntegrationsComponent);
    function FloatingIntegrationsComponent() {
        (0,_class_call_check/* default */.Z)(this, FloatingIntegrationsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FloatingIntegrationsComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFloatingIntegrationsComponent, {
                    className: "floating-integrations-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsSliderComponent, {
                        integrationBadges: duplicateBadges()
                    })
                });
            }
        }
    ]);
    return FloatingIntegrationsComponent;
}(react.PureComponent);



/***/ })

}]);